const SolutionSection = () => (
  <section className="bg-[#1E0750] py-16 px-8 lg:px-16">
    <div className="max-w-[860px] mx-auto text-center">
      <p className="text-white/60 font-semibold text-base mb-4 uppercase tracking-widest">Mais je te rassure...</p>
      <h2 className="text-white font-black text-3xl lg:text-4xl mb-4 leading-tight">
        Il existe une solution !
      </h2>
      <p className="text-[#A3E635] font-black text-2xl lg:text-3xl mb-6">
        La Méthode <span className="underline decoration-[#F0C932]">LS INVEST</span> &nbsp; l'ultime méthode pour investir en Bourse et construire ton indépendance
      </p>
      <p className="text-white/70 text-base leading-relaxed max-w-[640px] mx-auto">
        Une méthode complète, structurée et accessible, pensée pour les débutants comme pour ceux qui veulent aller plus loin. Tu auras accès à tout ce dont tu as besoin pour <strong className="text-white">bâtir un portefeuille performant</strong>, comprendre les marchés financiers et prendre les bonnes décisions.
      </p>
    </div>
  </section>
);

export default SolutionSection;
